import { render, staticRenderFns } from "./BlockedNumbersTab.vue?vue&type=template&id=62bbbd50&scoped=true&"
import script from "./BlockedNumbersTab.vue?vue&type=script&lang=js&"
export * from "./BlockedNumbersTab.vue?vue&type=script&lang=js&"
import style0 from "./BlockedNumbersTab.vue?vue&type=style&index=0&id=62bbbd50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bbbd50",
  null
  
)

export default component.exports